






















































































































import { Component, Emit, Vue, Watch } from 'vue-property-decorator'
import { Factories } from '@finx/web-repository'
import PagamentoStore from '@finx/web-repository/src/stores/Pagamento'
import { IuguCreditCard } from '@finx/web-repository/src/types/Iugu'

const component: Object = {
  store: {
    PagamentoStore,
  },
}

@Component(component)

export default class ComponentFormPagamento extends Vue {
  stores: any = {
    pagamento: (this.$store as any).PagamentoStore,
  }

  alert: any = {
    show: false,
    message: '',
  }

  card: IuguCreditCard = {
    first_name: '',
    last_name: '',
    number: '',
    expirationMonth: '',
    expirationYear: '',
    verification_value: '',
  }

  Messages: any = Factories.Messages
  Validator: any = Factories.Validator
  cardBrand: String = ''
  formIsValid: Boolean = false

  get loading() {
    return this.stores.pagamento.getters.LOADING
  }

  @Watch('card', { deep: true })
  watchCard() {
    this.alert.show = false
    this.alert.message = ''
  }

  getBrandCard() {
    // @ts-ignore
    const brand = Iugu.utils.getBrandByCreditCardNumber(this.card.number)
    if (brand) this.cardBrand = brand
  }

  @Emit('submit')
  submit(creditCard) {}

  validate() {
    const form = (this.$refs as any).formPagamento

    if (form.validate()) {
      this.stores.pagamento.commit('LOADING', true)
      this.validateIugu()
    }
  }

  validateIugu() {
    // @ts-ignore
    const creditCard = Iugu.CreditCard(
      this.card.number,
      this.card.expirationMonth,
      this.card.expirationYear,
      this.card.first_name,
      this.card.last_name,
      this.card.verification_value,
    )

    const creditCardIsValid = creditCard.valid()

    if (creditCardIsValid) this.submit(creditCard)
    else {
      this.alert.show = true
      this.alert.message = this.Messages('creditCard', 'error')

      this.stores.pagamento.commit('LOADING', false)
    }
  }
}
